export const getToken = state => state.login.token
export const getUser = state => state.login.user
export const getError = state => state.login.error
export const getOtpNeeded = state => state.login.otpNeeded
export const getTitle = state => state.pages.title
export const getFilters = state => state.pages.filters
export const getPageFilters = (state, url) => state.pages.filters.get(url)
export const getLoading = state => state.pages.loading
export const getRedirectTo = state => state.pages.redirectTo
export const getPreviousPath = state => state.pages.previousPath